module.exports = __webpack_public_path__ + "static/media/warning.4247738e.svg";